// eslint-disable-next-line no-unused-vars
import { createContext, h } from 'preact';

export const initialState = {
	currentSelections: [],
	facets: [],
	focusNewPost: false,
	focusPostId: 0,
	foundPosts: 0,
	loading: true,
	loadMore: false,
	maxNumPages: 0,
	page: 0,
	params: {},
	postCount: 0,
	posts: [],
	users: [],
	filterQueries: [],
	sectionName: '',
};

export const SearchContext = createContext( initialState );

/**
 *
 * @param {*} state
 * @param {*} action
 * @returns
 */
export const reducer = ( state, action ) => {
	const { type } = action;
	switch ( type ) {
			case 'SET_POSTS': {
				const { value, append } = action.payload;

				const focusPostId = value && value[0] ? value[0].id : '';

				if ( append ) {
					return {
						...state,
						posts: [...state.posts, ...value],
						focusPostId,
					};
				}

				return {
					...state,
					posts: [...value],
					focusPostId,
				};
			}
			case 'SET_FOCUS_NEW_POST': {
				const { value } = action.payload;

				return {
					...state,
					focusNewPost: value,
				};
			}
			case 'SET_LOADING': {
				const { value } = action.payload;

				return {
					...state,
					loading: value,
				};
			}
			case 'SET_LOAD_MORE': {
				const { value } = action.payload;

				return {
					...state,
					loadMore: value,
				};
			}
			case 'SET_PAGE': {
				const { value } = action.payload;

				return {
					...state,
					page: value,
				};
			}
			case 'SET_PARAMS': {
				const { value } = action.payload;

				return {
					...state,
					params: value,
				};
			}
			case 'SET_RESPONSE': {
				const { value } = action.payload;
				const {
					currentSelections,
					facets,
					foundPosts,
					maxNumPages,
					postsPerPage,
					users,
					filterQueries
				} = value;

				return {
					...state,
					currentSelections,
					facets,
					foundPosts,
					maxNumPages,
					postsPerPage,
					users,
					filterQueries
				};
			}
			case 'SET_SECTION_NAME': {
				const { value } = action.payload;
			
				return {
					...state,
					sectionName: value,
				};
			}
			default: {
				throw new Error( 'Unexpected action.' );
			}
	}
};
